import React from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import FilterWrap from "components/htmlElements/FilterWrap";
import CustomOption from "common/components/Select/assets/CustomOption";
import DropdownIndicator from "common/components/Select/assets/DropdownIndicator";

// SC-1 / D-03 / D-04: the Header language toggle.
// Clones the react-select config idiom from common/components/Select/SelectReusable
// (isSearchable:false, closeMenuOnSelect:true, the customDropdown FilterWrap wrapper,
// the shared DropdownIndicator/CustomOption), but drops ALL role/navigation
// side-effects — onChange only calls i18n.changeLanguage, which centrally drives
// dir + persistence via the languageChanged listener in i18n/index.ts (D-09/D-02).
const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const options = [
    { value: "en", label: t("languageEnglish") },
    { value: "he", label: t("languageHebrew") },
  ];

  const selectProps = {
    options,
    value: options.find((opt) => opt.value === i18n.resolvedLanguage),
    isRtl: i18n.dir() === "rtl",
    isSearchable: false,
    closeMenuOnSelect: true,
    components: { DropdownIndicator, Option: CustomOption },
    className: "react-select-container",
    classNamePrefix: "react-select",
    onChange: (selectedOption: any) => {
      selectedOption && i18n.changeLanguage(selectedOption.value);
    },
  };

  return (
    <FilterWrap className="filterWrap">
      <div className="customDropdown" data-testid="language-switcher">
        <Select {...selectProps} />
      </div>
    </FilterWrap>
  );
};

export default LanguageSwitcher;
